import { SendOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { usePostRequest } from 'hooks';

import { Transaction } from 'codegen';

export const SendTransaction = ({
  snapId,
  status,
  statusCode,
  transactionId,
}: {
  snapId?: number;
  status?: Transaction.status,
  statusCode?: number;
  transactionId?: number;
}) => {
  const [sendTransaction, { loading }] = usePostRequest({
    url: `/snaps/${snapId}/transactions/${transactionId}/issuance`,
  });

  const isBackedOut = status === Transaction.status.BACKED_OUT;
  const showSendBtn = !statusCode || statusCode === 500;

  if (!showSendBtn || isBackedOut) {
    return null;
  }

  return (
    <Button
      type='text'
      icon={<SendOutlined title='Send' className='text-[#52c41a]' />}
      loading={loading}
      onClick={() => sendTransaction()}
    />
  );
};
